import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const faqs = [
  {
    q: "Hva inngår i startprisen?",
    a: "Startprisen gjelder ferdig modul i valgt standardkonfigurasjon, med de standardmaterialene og den løsningen som er beskrevet for modellen. Lokale grunnarbeider og tilkoblinger er ikke inkludert."
  },
  {
    q: "Må jeg ha fundament?",
    a: "Ja, modulen må stå på et stabilt og riktig forberedt underlag. Fundament, grunnarbeid og lokal tilpasning prises normalt separat etter tomt og adkomst."
  },
  {
    q: "Hvem kobler til strøm og vann?",
    a: "Lokalt elektrisk arbeid, vann, avløp og frostsikring på tomten må utføres av godkjente lokale fagfolk. LYKKE kan beskrive kravene og koordinere grensesnittet."
  },
  {
    q: "Kan modellen tilpasses?",
    a: "Ja. Materialer, glass, gulv, lys, varme og enkelte funksjoner kan tilpasses. Større endringer vurderes som bespoke-prosjekt."
  },
];

export default function ToriFaqAccordion() {
  const [open, setOpen] = useState(null);

  return (
    <div className="border-t border-foreground/10">
      {faqs.map(({ q, a }, i) => (
        <div key={q} className="border-b border-foreground/10">
          <button
            onClick={() => setOpen(open === i ? null : i)}
            className="w-full flex items-center justify-between py-6 text-left gap-4"
          >
            <span className="font-heading text-2xl font-normal">{q}</span>
            <ChevronDown
              size={18}
              className={`flex-shrink-0 text-foreground/40 transition-transform duration-300 ${open === i ? "rotate-180" : ""}`}
            />
          </button>
          <AnimatePresence initial={false}>
            {open === i && (
              <motion.div
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: "auto", opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                transition={{ duration: 0.25 }}
                className="overflow-hidden"
              >
                <p className="text-foreground/60 text-2xl leading-relaxed font-body pb-6">{a}</p>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      ))}
    </div>
  );
}